module.exports = {
      id: "bundle-usage",
      viewBox: "0 0 15.204 15.204",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#bundle",
      toString: function () {
        return this.url;
      }
    }